import React from 'react';

import styles from './WhatMattersMost.module.scss';

const {
  'what-matters-most': whatMattersMostClass,
  'title-copy': titleCopyClass,
  'img-info-container': imgInfoContainerClass,
  'img-info': imgInfoClass
} = styles;

const WhatMattersMost = ({
  titleCopy = 'Why take care of it today?',
  imgArray = [],
  ctaCopy = '',
  ctaAction = () => {}
}) => {
  return (
    <div className={whatMattersMostClass}>
      <h2 className={titleCopyClass}>{titleCopy}</h2>
      <div className={imgInfoContainerClass}>
        {!!imgArray.length &&
          imgArray.map(({ url, title, subtitle }, idx) => (
            <div className={imgInfoClass} key={`${title}_${idx}`}>
              <img src={url} alt={`img-${idx}`} />
              <h3>{title}</h3>
              <p>{subtitle}</p>
            </div>
          ))}
      </div>
      {!!ctaCopy && <button onClick={ctaAction}>{ctaCopy}</button>}
    </div>
  );
};

export default WhatMattersMost;
